<template>
  <div>
    <div class="history_box">
      <div class="sug_history_title sug_title">
        <span class="fl">历史搜索</span>
      </div>
      <ul id="historyList">
        <li v-for="item in list">
          <a href="javascript:;" @click="addKeywordsToSearchInput">{{
            item
          }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'History',
  props: ['list'],
  data() {
    return {}
  },
  methods: {
    addKeywordsToSearchInput(e) {
      this.$emit('addKeywordsToSearchInput', e.target.innerText)
    }
  }
}
</script>

<style lang="less"></style>
